import { useParams } from 'react-router-dom';

const useGuid = () => {
  const { guid } = useParams();
  return guid;
};

export default useGuid;
